<template>
    <main>
        <agile :navButtons=false>
            <img class="slide" src="http://www.shengjia-resin.com/temp/1.jpg" />
            <img class="slide" src="http://www.shengjia-resin.com/temp/2.jpg" />
            <img class="slide" src="http://www.shengjia-resin.com/temp/3.jpg" />
        </agile>
        <div class="article-wrapper">
            <article>
                <ul class="news-list">
                    <li v-for="(n, index) in news" :key="index">
                        <div class="news-cal">
                            <div class="news-cal-day">{{n.date}}</div>
                            <div class="news-cal-month">{{n.month}}</div>
                        </div>
                        <!--<a :href="n.link">{{n.title}}</a>-->
                        <a href="#" @click="openwith(n.link)">{{n.title}}</a>
                    </li>
                </ul>
            </article>
        </div>
    </main>
</template>

<script>

    import qs from 'qs'
    import {
        VueAgile
    } from 'vue-agile'
    export default {
        name: 'Announcement',
        components: {
            agile: VueAgile
        },
        data() {
            return {
                newsDatas: [],
                newsType: '通知公告',
                news: [],
            }
        },
        created() {
            this.loadNews();
        },
        methods: {
            loadNews() {
                let params = {
                    newsType: this.newsType,
                };
                this.$axios.post('/findNewsList', qs.stringify(params)).then(res => {
                    this.newsDatas = res.data;
                    if(this.newsDatas != null && this.newsDatas.length > 0) {
                        for (let i=0;i<this.newsDatas.length;i++) {
                            if (this.newsDatas[i] != null) {
                                let timeData = new Date(this.newsDatas[i].timestamp).toDateString();
                                let monthData = timeData.substring(4,7);
                                let dateData = timeData.substring(8,10);

                                let content = this.newsDatas[i].content;
                                let urls = content.split("href=\"");
                                let url = urls[1].split(".pdf");
                                let href = url[0]+'.pdf';

                                let newspay = {
                                    date: dateData,
                                    month: monthData,
                                    title: this.newsDatas[i].title,
                                    link: href
                                };
                                this.news.push(newspay)
                            }
                        }
                    }
                }).catch(res => {
                    alert("数据获取失败")
                })
            },
            openwith(val){
                window.open(val)
            }
        }
    }
</script>

<style lang="less">
</style>